import { Link } from "react-router-dom";


export default function ItineraryCard({ itin, featured = false, disableLink = false }) {
  const isFree = itin.price_usd === 0;
  // disableLink: temporary GTM soft-launch flag (see src/config/softLaunch.js) — renders a
  // non-navigating div instead of a Link so hover effects stay but click does nothing.
  const Wrapper = disableLink ? "div" : Link;
  const wrapperProps = disableLink ? {} : { to: `/itinerary/${itin.slug}` };
  return (
    <Wrapper
      {...wrapperProps}
      className="card"
      data-testid={`itinerary-card-${itin.slug}`}
      style={featured ? { gridColumn: "span 2", display: "grid", gridTemplateColumns: "1.1fr 1fr" } : {}}
    >
      <div
        className="card-img"
        style={{
          backgroundImage: `${itin.cover_gradient ? `linear-gradient(135deg, rgba(0,0,0,0.05), rgba(0,0,0,0.02)),` : ""} url(${itin.cover_url})`,
          backgroundSize: "cover",
        }}
      >
        {itin.badge && <div className="stamp-mini">{itin.badge}</div>}
      </div>
      <div className="card-body" style={featured ? { padding: 36 } : {}}>
        <div className="card-region">
          {itin.destination_country} · {itin.duration_days} Days
        </div>
        <div className="card-title" style={featured ? { fontSize: 28 } : {}}>{itin.title}</div>
        {featured && (
          <p className="text-[13px] text-[var(--ink2)] leading-[1.55] mb-3">
            {itin.description}
          </p>
        )}
        <div className="card-tags">
          {itin.trip_type?.slice(0, 2).map((t) => (
            <span key={t} className="tag">{t}</span>
          ))}
          {isFree && <span className="tag" style={{ color: "var(--green)", borderColor: "var(--green)" }}>Free</span>}
          <span className="tag">{itin.budget_range}</span>
        </div>
        <div className="card-foot">
          <div className="card-by">
            <div
              className="av-sm"
              style={{ background: itin.seller?.accent_color || "var(--ink)" }}
            >
              {itin.seller?.initials || "??"}
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700 }}>{itin.seller?.name}</div>
              <div className="mono" style={{ color: "var(--ink3)", fontSize: 10, marginTop: 2 }}>
                Verified
              </div>
            </div>
          </div>
          {isFree ? (
            <span className="card-price-free">FREE</span>
          ) : (
            <div className="card-price">₹{Number(itin.price_usd)}</div>
          )}
        </div>
      </div>
    </Wrapper>
  );
}
